module.exports = __webpack_public_path__ + "img/boutique.8250014b.webp";